import { bool, object, objectOf, string } from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Pricing from '../../../Pricing/Pricing';
import PricingNew from '../../../Pricing/next/Pricing';
import PricingHelper from '../../../Pricing/PricingHelper';
import { cardThemes } from '../../ProductCard.config';

const ProductPrice = ({
    cardTheme,
    deviceType,
    displayEach,
    eligibilityMessage,
    ppId,
    price,
    pricingConfig,
    fromHotDeals,
    enableOptimizedPricing,
}) => {
    const isCartridgeTheme = cardTheme === 'cartridge';
    const priceWrapper = `${dt([
        'flex',
        'flex-wrap',
        'items-baseline',
        'm-0',
        'pt-0',
        'text-md',
        fromHotDeals ? 'lg:!whitespace-normal' : 'whitespace-normal',
    ])} ${isCartridgeTheme ? dt(['overflow-hidden', 'text-xs']) : ''}`;
    const mainPrice = `${isCartridgeTheme ? dt(['inline-block', 'text-xs']) : ''}`;

    return (
        <div
            className={cardTheme}
            data-automation-id="product-price"
            data-component-name="ProductPrice"
        >
            {enableOptimizedPricing ? (
                <PricingNew
                    cardTheme={cardTheme}
                    deviceType={deviceType}
                    displayEach={displayEach}
                    dynamicFont={cardTheme === cardThemes?.CARTRIDGE}
                    eligibilityMessage={eligibilityMessage}
                    mainPriceClass={mainPrice}
                    ppId={ppId}
                    priceWrapperClass={priceWrapper}
                    pricingConfig={pricingConfig}
                    pricingDetails={PricingHelper(price)}
                />
            ) : (
                <Pricing
                    cardTheme={cardTheme}
                    deviceType={deviceType}
                    displayEach={displayEach}
                    dynamicFont={cardTheme === cardThemes?.CARTRIDGE}
                    eligibilityMessage={eligibilityMessage}
                    mainPriceClass={mainPrice}
                    ppId={ppId}
                    priceWrapperClass={priceWrapper}
                    pricingConfig={pricingConfig}
                    pricingDetails={PricingHelper(price)}
                />
            )}
        </div>
    );
};

ProductPrice.propTypes = {
    cardTheme: string,
    deviceType: objectOf(bool),
    displayEach: bool,
    eligibilityMessage: string,
    ppId: string,
    price: object,
    pricingConfig: object,
    fromHotDeals: bool,
    enableOptimizedPricing: bool,
};

ProductPrice.defaultProps = {
    cardTheme: '',
    deviceType: {},
    displayEach: false,
    eligibilityMessage: '',
    ppId: '',
    price: null,
    pricingConfig: {},
    fromHotDeals: false,
    enableOptimizedPricing: false,
};

export default ProductPrice;
